import { FormFieldMetaDataProps } from "./form-metadata";

const permitsAndCertificates: FormFieldMetaDataProps[] = [
    {
        label: "Number of  building completion certificates for Villas",
        id: "number_of_building_completion_certificates_for_villas",
        type: "text",
    },
    {
        label: "Number of building permits for Villas",
        id: "number_of_building_permits_for_villas",
        type: "text",
    },
    {
        label: "QA/QC ISO status",
        id: "qa_qc_iso_status",
        type: "text",
    },
    {
        label: "OSHAD status",
        id: "oshad_status",
        type: "text",
    }
]

export {
    permitsAndCertificates
}